import React, { useCallback } from 'react'
import { useLocalization } from '@/hooks/localization'
import { DropDownList } from '@/components/dropDownList'

function NullableBooleanDropDownList ({ value, onChange, ...rest }) {
  const { localize } = useLocalization()
  const handleChange = useCallback(e => {
    let value = null
    if (e.value === 'true') value = true
    if (e.value === 'false') value = false
    onChange({ ...e, value })
  }, [onChange])
  const data = [
    { value: 'false', text: localize('Common.No') },
    { value: 'true', text: localize('Common.Yes') }
  ]
  return (
    <DropDownList
      textField='text'
      valueField='value'
      data={data}
      value={typeof value === 'boolean' ? `${value}` : null}
      onChange={handleChange}
      allowClear
      {...rest}
    />
  )
}

export {
  NullableBooleanDropDownList
}



// WEBPACK FOOTER //
// ./src/components/nullableBooleanDropDownList.js